import SubmitButton from 'components/ui/buttons/SubmitButton';
import DataForm from 'components/ui/DataForm';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

const DatasetForm = ({ schema, formData, onSubmit, disabled, back }) => {
  const { t } = useTranslation();
  delete schema.title;

  return useMemo(
    () => (
      <DataForm schema={schema} formData={formData} disabled={disabled} onSubmit={onSubmit}>
        <div className="d-flex justify-content-end mt-5">
          <button type="button" className="btn btn-outline-secondary me-2" disabled={disabled} onClick={back}>
            {t('actions.cancel')}
          </button>

          <SubmitButton type="submit" className="btn btn-primary" disabled={disabled} />
        </div>
      </DataForm>
    ),
    [formData]
  );
};

export default DatasetForm;
